import React from 'react';
export default function AccountSettings() {
    const stored = localStorage.getItem("user");
    const userData = stored ? JSON.parse(stored) : {};
    const userId = userData.id;
    const token = userData.token;

    const openStripePortal = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/billing/portal`, {

                headers: {Authorization: `Bearer ${token}`}
            });

            if (response.ok) {
                const data = await response.json();
                window.location.href = data.url; // Redirect to the Stripe Customer Portal
            } else {
                console.error('Failed to create portal session');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    return (
        <div style={{padding: '20px'}}>
            <h2>Account Settings</h2>
            <button onClick={openStripePortal} style={{padding: '10px 20px', fontSize: '16px'}}>
                Manage Subscription
            </button>
        </div>
    );
}